import { Box, InputLabel, Select, Tooltip, FormControl, OutlinedInput, Input, Icon } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import React, { FC, ReactNode, useState } from "react";

export interface ViewEditSelectProps {
  props: {
    id: string;
    disableShrinkLabel?: boolean;
    isEdit: boolean;
    label: string;
    menuProps?: any;
    multiple?: boolean;
    required?: boolean;
    size?: "small" | "medium";
    tooltip?: string;
    value?: string | string[]; // Should only be string[] when "multiple" is true
    handleInputChange: (newValue: any, field: string) => void;
    renderValue?: (value: any) => ReactNode
  };
}

const ViewEditSelect: FC<ViewEditSelectProps> = ({ props, children }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleTooltip = (isOpen: boolean) => {
    setTooltipOpen(isOpen);
  };

  const classNames = ["view-edit-box"];
  if (!props.isEdit) classNames.push("read-only");

  const shrinkLabel = (props.isEdit && !props.disableShrinkLabel) || (props.value ? true : false);

  return (
    <Box m={1} className={classNames.join(" ")}>
      <Tooltip open={tooltipOpen} title={props.tooltip ?? ""}>
        <FormControl required={props.required} variant={props.isEdit ? "outlined" : "standard"} margin="dense" size={props.size || "small"} fullWidth>
          <InputLabel shrink={shrinkLabel}>{props.label}</InputLabel>
          <Select
            fullWidth
            IconComponent={props.isEdit ? ArrowDropDownIcon : Icon}
            input={props.isEdit ? <OutlinedInput notched={shrinkLabel} label={props.label} /> : <Input />}
            inputProps={{
              readOnly: !props.isEdit,
            }}
            label={props.label}
            multiple={props.multiple}
            MenuProps={props.menuProps}
            renderValue={props.renderValue}
            value={props.value || ""}
            onMouseEnter={() => {
              handleTooltip(true);
            }}
            onMouseLeave={() => {
              handleTooltip(false);
            }}
            onOpen={() => {
              handleTooltip(false);
            }}
            onChange={(e) => props.handleInputChange(e.target.value, props.id)}
          >
            {children}
          </Select>
        </FormControl>
      </Tooltip>
    </Box>
  );
};

export default ViewEditSelect;
